import YandexMapLoader from "./../ymap";
import {findID} from "../../../../../../modules/vegas/js/util";
import axios from "axios";


function onReady() {
	let map = findID('yaMapRegions');
	let tmBalloon;
	let polygonOpenedByClick = false;

	if (map) {
		let myMap;
		new YandexMapLoader().loadIfVisible(map, () => {
			myMap = myMap = makeInteractiveMap('yaMapRegions');

			const regions = JSON.parse(map.getAttribute('data-points'));

			myMap.balloon.events.add('close', () => {
				polygonOpenedByClick = false;
			});

			function addRegionPolygon(coordinates, r) {
				let myPolygon = new ymaps.Polygon([coordinates], {}, {
					fillColor: interactiveMapDefaultColors[r.type].fillColor,
					strokeColor: interactiveMapDefaultColors[r.type].strokeColor,
					strokeWidth: 1.5,
					zIndex: 4000,
				});

				myPolygon.events.add('click', () => {
					polygonOpenedByClick = true;
				});

				myPolygon.events.add('mouseenter', function () {
					clearInterval(tmBalloon);
					myPolygon.options.set({
						fillColor: interactiveMapHoverColors[r.type].fillColor,
						strokeColor: interactiveMapHoverColors[r.type].strokeColor,
					});

					let balloonContent = `
						<div class="client-ballon">
							<i>
								<img src="/assets/_frontend/images/icons/icon-location.svg" alt="Иконка" width="22" height="22">
							</i>
							${r.name}
						</div>
					`;

					let center = myPolygon.geometry.getBounds();
					let centerCoordinates = [
						(center[0][0] + center[1][0]) / 2,
						(center[0][1] + center[1][1]) / 2
					];

					myMap.balloon.open(centerCoordinates, balloonContent);
				});

				myPolygon.events.add('mouseleave', function () {
					myPolygon.options.set({
						fillColor: interactiveMapDefaultColors[r.type].fillColor,
						strokeColor: interactiveMapDefaultColors[r.type].strokeColor,
					});
				});

				myPolygon.events.add('mouseleave', function () {
					if (polygonOpenedByClick) return;
					tmBalloon = setInterval(() => {
						let hovered = document.querySelector('ymaps[class*="balloon"]:has(.client-ballon):hover');

						if (!hovered) {
							myMap.balloon.close();

							clearInterval(tmBalloon);
						}
					}, 300);
				});

				myMap.geoObjects.add(myPolygon);
			}

			let ids = regions.map(r => r.id);
			axios.get(map.dataset.routeGetGeo, {
				params: {ids: ids}
			}).then(response => {
				regions.forEach(r => {
					let coordinates = response.data.coords[r.id] || [];

					for(let coords of coordinates) {
						addRegionPolygon(coords, r);
					}
				});
			});
		});
	}
}

document.addEventListener('DOMContentLoaded', onReady);
